const BaseModule = require('../../../../90_utils/base/BaseModule');

class ClickToPlayVideo extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$plyrVideo = this.$el.find('[data-plyr-video]');
	}

	// basemodule methods

	_domReady(){
		this.$plyrVideo.triggerHandler('plyr-init');
	}

	_addListeners(){

		this.$el.find('.inner-content').on('click', $.proxy(this._onClick, this));

		if(this.$plyrVideo.hasClass('video-playing')){
			this._showPlayer();
		}
		else {
			this.$plyrVideo.on('playing', $.proxy(this._onVideoPlaying, this));
		}
	}

	_removeListeners(){

		this.$el.find('.inner-content').off('click', $.proxy(this._onClick, this));
		this.$plyrVideo.off('playing', $.proxy(this._onVideoPlaying, this));
	}

	//

	_onClick(e){

		if(window.SETTINGS.breakpoint.minWidth('screen-small')){

			this.$el.find('.inner-content').off('click', $.proxy(this._onClick, this));

			let $playButton = this.$el.find('.video-play');
			TweenMax.to($playButton, 0.2, {scale:1.1, ease:Cubic.easeIn});
			TweenMax.to($playButton, 0.2, {scale:0.9, opacity:0, ease:Quad.easeOut, delay:0.2});

			let $title = this.$el.find('.title');
			if($title.length){
				TweenMax.to($title, 0.5, {opacity:0, ease:'fade'});
			}

			let $spinner = this.$el.find('.circle-loader');
			TweenMax.to($spinner, 1, {opacity:1, delay:0.5, ease:'fade'});
			TweenMax.to($spinner, 3, {rotation:'+=360', repeat:-1, ease:Linear.none});

			this._play();
		}
	}

	_onVideoPlaying(e){
		this._showPlayer();
		this.$plyrVideo.off('playing', $.proxy(this._onVideoPlaying, this));
	}

	//

	_play(){
		if(!this.$el.hasClass('is-playing')){
			this.$el.find('[data-plyr-video]').triggerHandler('plyr-play');
		}
	}

	_pause(){

	}

	// hide poster

	_showPlayer(){

		let $playButton = this.$el.find('.video-play');
		let $spinner = this.$el.find('.circle-loader');

		window.setTimeout(() => {
			TweenMax.killTweensOf([$playButton, $spinner]);
		}, 500);

		this.$el.addClass('is-playing');
	}

	//

	_show(){}

	_hide(){}

	_enable(){ }
	_disable(){ }

	_domUpdate(){

	}
	_resize(){

	}
}

module.exports = ClickToPlayVideo;
